module.exports = __webpack_public_path__ + "static/mid-d5f348dc1cd060adb3b20c8efc51640b.png";